import { viewButterBarBasedOnUserPreference, closeButterBar } from './butter-bar-2.0';

viewButterBarBasedOnUserPreference();
document.getElementById('btn-close-butter-bar')?.addEventListener('click', () => closeButterBar());
